import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const updateCharge = async ({
    token,
    jsonData,
}) => {

    try {
        const res = await axiosCreate.put('/charge', {
            ...jsonData
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}

/** jsonData Example
 * {
    "charge_id": 1,
    "name": "",
    //Puede ir null
    "late_fee": {
        "enabled": true,
        "charge_late_fee_type_id": 2,
        "value": 10
    },
    //Puede ir null
    "recurrence": {
        "charge_recurrence_frequency_id": 8,        
        "issue_date": "2025-02-25",
        "due_date": "2025-03-30"
    },
    //Puede ir un arreglo vacio
   "debtors": [
        {
            "place_id": 1862,
            "details": [
                {
                    "charge_item_id": 81,
                    "total": 18.23
                }
            ],
            "taxes": [
                {
                    "charge_tax_id": 1,
                    "total": 2.18
                }
            ],
            "totals": {
                "taxable_total": 18.23,
                "tax_total": 2.18,
                "total": 20.41
            }
        }        
    ]
}
 */